enum Mode {
    CONNECT = 0,
    CREATE_PIN = 1,
    RELOGIN = 2,
    MAIN = 3,
}

export default Mode;